module.exports = __webpack_public_path__ + "static/media/Demo PsyTun.0ab2b751.mp4";